/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'
import { formatTime } from '../util.js'

const camelize = str =>
  str.replace(/(-|_|\s)+(.)?/g, function (match, separator, chr) {
    if (chr) { return chr.toUpperCase() } else { return '' }
  })

/*
 * Base model that includes some helpers
 *
 * @namespace Model
 */
class Base extends Backbone.Model {
  include (mod) {
    return _.extend(this, mod(this))
  }

  templateAttrs (attrs) {
    const attrList = (typeof attrs.split === 'function' ? attrs.split(' ') : undefined) || attrs

    const result = {}

    for (const attr of Array.from(attrList)) {
      const camelized = camelize(attr)

      if (this.has(attr)) {
        result[camelized] = this.get(attr)
      } else if (this[camelized]) {
        result[camelized] = this[camelized]()
      } else {
        /*
         * explicitly set a key with the value undefined
         * so that the template can still reference the
         * key without blowing up
         */
        result[camelized] = undefined
      }
    }

    return result
  }

  /*
   * Does a partial update of this object. Attempts to (partially) emulate
   * `save`. However, only the specified attributes will be sent to the server.
   * If none of the specified attributes are different from their current values
   * then no request is made to the server and a false value is returned.
   * If at least one of the specified attributes is different from the current
   * values, then all the specified attributes are sent to the server, and a
   * true value is returned.
   * TODO: Stop using this. Use the Backbone 1.0.0 built-in patch option to
   *       the save method instead. See http://backbonejs.org/#Model-save
   */
  patch (attrs) {
    const changed = _.any(_.keys(attrs), function (key) {
      return this.get(key) !== attrs[key]
    }
    , this)

    if (changed) {
      this.set(attrs)
      return Backbone.ajax({
        url: _.result(this, 'url'), // TODO: Use some wrapper so we don't have to use _.result all over.
        type: 'patch',
        data: attrs,
        success: (data, textStatus, jqXHR) => {
          this.set(this.parse(data)) // We get the updated attributes, so let's use them.
          return this.trigger('sync', this, data, { changes: attrs })
        },
        error: (jqXHR, textStatus, errorThrown) => {
          return this.trigger('error', this, jqXHR, { changes: attrs })
        }
      })
    }
  }

  /*
   * Requests the latest data from the server, but only updates the specified
   * attribute(s).
   */
  fetchAttrs (attrs, options) {
    if (options == null) { options = {} }
    if (!_.isArray(attrs)) {
      attrs = [attrs]
    }
    attrs = _.compact(attrs)
    if (attrs.length !== 0) {
      return Backbone.ajax({
        url: _.result(this, 'url'),
        type: 'get',
        success: (data, textStatus, jqXHR) => {
          this.set(_.pick(this.parse(data), attrs))
          return (typeof options.success === 'function' ? options.success(data, textStatus, jqXHR) : undefined)
        },
        error: options.error
      })
    }
  }

  // Remove event bindings that were created with `.on`
  cleanUp () {
    return this.off()
  }

  formattedTime () {
    let time
    if (!(time = this.get('created_at'))) { return }

    return formatTime(time)
  }

  /*
   * Pass model through to ajax prefilter so we can set basic auth
   * credentials on a per model basis
   */
  sync (method, model, options) {
    if (options == null) { options = {} }
    options.model = model
    return super.sync(method, model, options)
  }
}

export default Base
